import {PAY_AUTH_DOMAIN_ALT} from '~/constants/authorize';
import type {OAuthParams} from '~/types/oauth';

export interface UrlParams extends OAuthParams {
  analyticsContext: string;
  analyticsTraceId: string;
  flow: string;
}

export function buildShopLoginInputUrl(params: UrlParams): string {
  /* eslint-disable @typescript-eslint/naming-convention */
  const searchParams = new URLSearchParams({
    analytics_context: params.analyticsContext || '',
    analytics_trace_id: params.analyticsTraceId || '',
    client_id: params.clientId,
    code_challenge: params.codeChallenge || '',
    code_challenge_method: params.codeChallengeMethod || '',
    flow: params.flow,
    redirect_type: params.redirectType || '',
    redirect_uri: params.redirectUri || '',
    response_mode: params.responseMode || '',
    response_type: params.responseType || '',
    scope: params.scope || '',
    state: params.state || '',
  });
  /* eslint-enable @typescript-eslint/naming-convention */

  return `${PAY_AUTH_DOMAIN_ALT}/pay/shop-auth-input?${searchParams}`;
}
